import Tabs from '../components/SettingsTabs';
import { Route, Routes, useLocation, useNavigate, Navigate } from 'react-router-dom';
import Dashboard from './dashboard';
import HomeGuide from './Home';
import IntegrationHelpLink from '../components/IntegrationHelpLink';
import { integrationHelp } from '../utils/helpCenter';
import EmailMarketing from './emailMarketing';
import GoogleSheets from './GoogleSheets';
import Pixels from './Pixels';
import Settings from './Settings';
import Upsell from './Upsell';
import PaymentIntegration from './PaymentIntegration';
import CodSettings from './CodSettings';
import Administration from './Administration';
import GoogleMaps from './GoogleMaps';
import TrafficProtection from './TrafficProtection';
import ExchangeRates from './ExchangeRates';
import ShopifyNavigation from '../components/ShopifyNavigation';
import OrderVerification from './OrderVerification';
import './AdminSettings.css';

const online = [['/online/payment-integration', 'Payment integration'], ['/online/checkout-settings', 'Settings'], ['/online/upsell', 'Upsell']];
const integrations = [['/integrations/pixels', 'Pixels & events'], ['/integrations/email-marketing', 'Email Marketing'], ['/integrations/google-sheets', 'Google Sheets'], ['/integrations/traffic-protection', 'Traffic protection'], ['/integrations/google-maps', 'Google Maps'], ['/integrations/order-verification', 'Order verification']];
const aliases = { '/online': online[0][0], '/integrations': integrations[0][0], '/payment_integration': online[0][0], '/settings': online[1][0], '/upsell': online[2][0], '/pixels': integrations[0][0], '/piexl': integrations[0][0], '/EmailMarketing': integrations[1][0] };
export default function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const tabs = location.pathname.startsWith('/online') ? online : location.pathname.startsWith('/integrations') ? integrations : [];
  const title = tabs === online ? 'Online payments' : tabs === integrations ? 'Integrations' : location.pathname === '/administration' ? 'Administration' : '';
  return <><ShopifyNavigation />
    {title && <div className="settings-nav"><div className="integration-title-row"><h1>{title}</h1>{tabs === integrations && <IntegrationHelpLink article={integrationHelp[location.pathname]} />}</div>{tabs.length > 0 && <Tabs
      tabs={tabs.map(([id, content]) => ({ id, content }))} selected={Math.max(0, tabs.findIndex(([path]) => path === location.pathname))}
      onSelect={index => navigate(tabs[index][0] + location.search)} />}</div>}
    <Routes>
      {Object.entries(aliases).map(([path, target]) => <Route key={path} path={path} element={<Navigate to={target + location.search + location.hash} replace />} />)}
      <Route path="/index" element={<Dashboard />} />
      <Route path="/" element={<HomeGuide />} />
      <Route path="/online/payment-integration" element={<PaymentIntegration key={location.key} />} />
      <Route path="/online/checkout-settings" element={<Settings />} />
      <Route path="/online/upsell" element={<Upsell />} />
      <Route path="/integrations/pixels" element={<Pixels />} />
      <Route path="/integrations/email-marketing" element={<EmailMarketing />} />
      <Route path="/integrations/google-sheets" element={<GoogleSheets />} />
      <Route path="/integrations/traffic-protection" element={<TrafficProtection />} />
      <Route path="/integrations/google-maps" element={<GoogleMaps />} />
      <Route path="/integrations/order-verification" element={<OrderVerification />} />
      <Route path="/administration" element={<Administration />} />
      <Route path="/exchange-rates" element={<ExchangeRates/>} />
      <Route path="/cod" element={<CodSettings />} />
    </Routes>
  </>;
}
